import type { BoxProps, MotionPropsFor } from '@hover/blueprint';
import { Box, forwardRef, motion } from '@hover/blueprint';
import { breakpoints } from '@hover/blueprint/foundation';
import React from 'react';

interface FullWidthContainerProps extends BoxProps {
  children: React.ReactNode;
}

interface AnimatedFullWidthContainerProps
  extends MotionPropsFor<FullWidthContainerProps> {
  children: React.ReactNode;
}

const MotionBox = motion(Box);

export const FullWidthContainer = ({
  children,
  paddingX = { base: 500, tablet: 800 },
  ...props
}: FullWidthContainerProps) => (
  <Box alignItems="center" justifyContent="center" w="100vw" {...props}>
    <Box maxWidth={breakpoints.width500} paddingX={paddingX} w={1}>
      {children}
    </Box>
  </Box>
);

export const AnimatedFullWidthContainer = forwardRef<
  AnimatedFullWidthContainerProps,
  'div'
>(({ children, ...props }, ref) => (
  <MotionBox ref={ref} {...props}>
    <FullWidthContainer>{children}</FullWidthContainer>
  </MotionBox>
));
